// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBRow } from 'mdbreact';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';
import FilePreviewElement from '../../layout/FilePreviewElement';
import getFileInfo from '../../../utils/getFileInfoForDisplay';

const UploadDeliverables = ({
                                auth,
                                currentWorkOrder,
                                uploadDocument,
                                deleteUpload,
                                toggleModal,
                                documentsDownloadInProcess,
                                setDocumentsDownloadInProcess
                            }) => {
    const { user } = auth;
    const isClient = user.userType === 'client';
    const isContractor = user.userType === 'contractor';
    const isSuperAdmin = user.userType === 'superAdmin';
    const workOrderId = currentWorkOrder?._id;
    const workOrderControlByStatus = workOrderStatusControl(currentWorkOrder?.status || '');

    const handleDownloadAll = () => {
        setDocumentsDownloadInProcess(true);
        axios.post(
            '/api/users/fetch_file',
            { workOrderId },
            { responseType: 'blob' },
        )
            .then(response => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data], { type: 'application/zip' })
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${currentWorkOrder.WIN}_${workOrderId}.zip`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                setDocumentsDownloadInProcess(false);
            })
            .catch(error => {
                console.error('Error downloading the file:', error);
                setDocumentsDownloadInProcess(false);
            });
    };

    const handleFileUpload = (event) => {
        const { files } = event.target;
        if (files && files.length) {
            const fd = new FormData();
            fd.append('workOrderId', workOrderId);
            Array.from(files).forEach(file => fd.append('files', file));
            fd.append('isDeliverables', true);
            uploadDocument(fd);
        }
    };

    const confirmDelete = (index) => {
        toggleModal(
            true,
            'confirmModal',
            true,
            {
                onAccept: () => deleteUpload(currentWorkOrder.uploadDeliverables[index], workOrderId),
                header: 'Are you sure you want to delete this file?',
                buttonLabels: { reject: 'Cancel' },
            },
        );
    };

    if (!currentWorkOrder || (!isClient && !isSuperAdmin && currentWorkOrder.contractor_id !== user.id)) {
        return null;
    }

    return (
        <div className="line_blocks">
            <div className="block_label">Upload Deliverables</div>

            <div className="fields_group">
                {(isClient || isSuperAdmin) && (
                    <div className="add_btns">
                        <label className="standard_btn icon_upload" style={{ cursor: 'pointer' }}>
                            <input
                                type="button"
                                style={{ display: 'none' }}
                                onClick={handleDownloadAll}
                                disabled={documentsDownloadInProcess}
                            />
                            {documentsDownloadInProcess
                                ? <>Downloading... <Spinner animation="border" size="sm" variant="light" /></>
                                : 'Download all documents'}
                        </label>
                    </div>
                )}

                {(isContractor || isClient) && workOrderControlByStatus.inWork && (
                    <div className="add_btns">
                        <label className="standard_btn icon_upload">
                            <input
                                type="file"
                                name="file_attach"
                                multiple
                                disabled={currentWorkOrder.onHold}
                                onChange={handleFileUpload}
                            />
                            Upload file
                        </label>
                    </div>
                )}

                {isContractor && currentWorkOrder.isNeedDeliverables &&
                    (!currentWorkOrder.uploadDeliverables?.length) && (
                        <div style={{ color: 'orange', fontSize: 13, marginTop: 5 }}>
                            To Complete Upload Deliverables Required!
                        </div>
                    )}

                <MDBRow style={{ marginTop: '15px' }}>
                    {currentWorkOrder.uploadDeliverables?.length
                        ? currentWorkOrder.uploadDeliverables.map((data, i) =>
                            FilePreviewElement({
                                fileInfo: getFileInfo(data),
                                index: i,
                                data,
                                toggleModal,
                                removeImage:
                                    isContractor && workOrderControlByStatus.inWork ? confirmDelete : false,
                            })
                        )
                        : <div style={{ fontSize: 13, color: '#777' }}>No deliverables uploaded yet.</div>}
                </MDBRow>
            </div>
        </div>
    );
};

export default UploadDeliverables;
